
export default function Info() {
  return (
    <div className="bg-white py-16 sm:py-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-base font-semibold leading-7 text-sky-600">ABOUT US</h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            We're here for you!
          </p>
          <p className="mt-6 text-lg leading-8 text-gray-600">
            Tranquil is designed to help you find a moment of peace in your hectic schedule and provide you a safe space to process your thoughts and emotions. Our team is devoted to come up with creative solutions to assist you in your healing journey. We're glad to have you here with us and we're sending lots of positive and calming energy your way! You're enough and you're never alone!
          </p>
        </div>
      </div>
    </div>
  )
}
